import type { ComponentProps, FunctionComponent } from 'react';

import styled from 'styled-components';
import { spacingHelper, mediaHelper, paletteHelper, radiusHelper } from '@property.com.au/ui-kit';
import { CallToActionBrick } from '../CallToActionBrick/CallToActionBrick';
import dashboardEstimatedValuePng from '../../../assets/dashboard-estimated-value.png';
import dashboardEstimatedValueAvif from '../../../assets/dashboard-estimated-value.avif';
import { HOME_TRACKING_SOURCE } from '../../../helpers/tracking';
import { clickThroughSourceTracking } from '../../../analytics/click-through-tracking/clickThroughSourceTracking';
import { SourceType } from '../../../analytics/click-through-tracking/TrackingSource';

const CTABanner = styled.div`
  display: flex;
  border-radius: ${radiusHelper('extraLarge')};
  margin: ${spacingHelper('0 extraSmall')};
  background: ${paletteHelper('backgroundSecondaryBase')};

  ${mediaHelper('tabletMin')} {
    margin: ${spacingHelper('0 large')};
  }
`;

export const BeInformedBrick: FunctionComponent = () => {
  const subheading = 'Insights and Comparisons';
  const title = "Keep a close eye on your own property's performance";
  const subtitle =
    "Follow your property to see personalised insights into how your property and it's location are performing.";

  const actionItems = [
    {
      id: 'be-informed-brick-cta',
      href: '/join-us/',
      variant: 'button-outline',
      sizeVariant: 'medium',
      children: 'Sign up for free and get started',
      onClick: () =>
        clickThroughSourceTracking({
          pathname: '/join-us/',
          page: HOME_TRACKING_SOURCE,
          element: 'home_page_be_informed_brick_cta',
          sourceType: SourceType.web,
        }),
    },
  ] satisfies ComponentProps<typeof CallToActionBrick>['actionItems'];

  const image = {
    avifImage: dashboardEstimatedValueAvif,
    pngImage: dashboardEstimatedValuePng,
    alt: 'Follow Your Property',
  };

  return (
    <CTABanner>
      <CallToActionBrick
        subheading={subheading}
        title={title}
        subtitle={subtitle}
        image={image}
        imagePlacement="left"
        actionItems={actionItems}
      />
    </CTABanner>
  );
};
